export default __webpack_public_path__ + "static/carbon-free-brasil-0e5b45a5268fd162957a7640409ba53e.png";